import React, { useState, useEffect, useContext, useRef } from "react";
import MyContext from "../../context/MyContext";

const SlideSettings = (props) => {
  const { calculateWidthByDuration, calculateTimeByWidth, onePxEquivalent } =
    useContext(MyContext);

  const [currentData, setcurrentData] = useState({
    key: null,
    point: null,
    activeTransition: "none",
  });

  const [CurrentLayerData, setCurrentLayerData] = useState(null);

  const [Show, setShow] = useState(false);
  const totalTimeToMs = (TotalLength) => {
    let timeSplitted = TotalLength.split(":");
    let hours = parseInt(timeSplitted[0]);
    let mins = parseInt(timeSplitted[1]);
    let sec = parseInt(timeSplitted[2]);
    let ms = parseInt(timeSplitted[3]);
    let hoursToMs = hours * 60 * 60 * 1000;
    let minsToMs = mins * 60 * 1000;
    let secToMs = sec * 1000;
    return hoursToMs + minsToMs + secToMs + ms;
  };
  useEffect(() => {
    if (props.style != null) {
      const array = Array.from(props.LayersData);
      for (let i = 0; i < array.length; i++) {
        if (array[i].key == props.style.layerKey) {
          setCurrentLayerData(array[i]);
          break;
        }
      }

      if (
        props.style.layerKey != currentData.key &&
        props.style.transitionPosition != currentData.point
      ) {
        setShow(true);
        let obj = {
          key: props.style.layerKey,
          point: props.style.transitionPosition,
          activeTransition: props.style.currentTransition,
        };
        setcurrentData(obj);
      } else {
        if (
          props.style.layerKey == currentData.key &&
          props.style.transitionPosition != currentData.point
        ) {
          setShow(true);
          let obj = {
            key: props.style.layerKey,
            point: props.style.transitionPosition,
            activeTransition: props.style.currentTransition,
          };
          setcurrentData(obj);
        } else {
          setShow(true);
          let obj = {
            key: props.style.layerKey,
            point: props.style.transitionPosition,
            activeTransition: props.style.currentTransition,
          };
          setcurrentData(obj);
        }
      }
    } else {
      setShow(false);
      let obj = {
        key: null,
        point: null,
        activeTransition: "none",
      };
      setcurrentData(obj);
    }
  }, [props.style]);

  const msToTime = (s) => {
    function pad(n, z) {
      z = z || 2;
      return ("00" + n).slice(-z);
    }
    var ms = s % 1000;
    s = (s - ms) / 1000;
    var secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    var hrs = (s - mins) / 60;
    return (
      pad(hrs) +
      ":" +
      pad(mins) +
      ":" +
      pad(secs) +
      ":" +
      pad(Math.round(ms), 3)
    );
  };
  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  let array;
  const settransition = (types) => {
    array = Array.from(props.LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key == currentData.key) {
        array[i].Added = true;
        if (currentData.point == "start") {
          let effectConfigured = true;
          // if (array[i].startTransitionWidth == 0) {
          //   array[i].startTransitionWidth = calculateWidthByDuration('00:00:00:500')
          //   alert(array[i].startTransitionWidth)
          // }
          if (array[i].text == "" && array[i].text != array[i].originalText) {
            array[i].text = array[i].originalText;
            array[i].fontSize = array[i].originalFontSize;
          }
          if (types == "TypeWriterr") {
            var txt = array[i].text;
            var speed = 50;
            for (let j = 0; j < txt.length; j++) {
              if (
                txt.charAt(j) == "<" &&
                txt.charAt(j + 1).toLowerCase() == "b" &&
                txt.charAt(j + 2).toLowerCase() == "r" &&
                txt.charAt(j + 3).toLowerCase() == ">"
              ) {
                speed = speed + 50;
                j = j + 4;
              } else if (
                txt.charAt(j) == "&" &&
                txt.charAt(j + 1).toLowerCase() == "n" &&
                txt.charAt(j + 2).toLowerCase() == "b" &&
                txt.charAt(j + 3).toLowerCase() == "s" &&
                txt.charAt(j + 4).toLowerCase() == "p" &&
                txt.charAt(j + 5).toLowerCase() == ";"
              ) {
                speed = speed + 50;
                j = j + 6;
              } else {
                speed = speed + 50;
              }
            }
            array[i].startTransitionWidth = calculateWidthByDuration(
              msToTime(speed)
            );
          } else if (
            types == "TextBounce" ||
            types == "Rolling" ||
            types == "TypeWriter"
          ) {
            var txt = array[i].text;
            let charactersArray = [];
            let cleanCharacterArray = [];
            let character = "";
            let calculatedTime = 0;

            for (let j = 0; j < txt.length; j++) {
              if (
                txt.charAt(j) == "<" &&
                txt.charAt(j + 1).toLowerCase() == "b" &&
                txt.charAt(j + 2).toLowerCase() == "r" &&
                txt.charAt(j + 3).toLowerCase() == ">"
              ) {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  character: character,
                  next: "<br>",
                  startAt: calculatedTime,
                };
                if (character != "") {
                  calculatedTime += 40;
                  cleanCharacterArray.push(obj);
                }
                charactersArray.push(obj);
                character = "";
                j = j + 3;
              } else if (
                txt.charAt(j) == "&" &&
                txt.charAt(j + 1).toLowerCase() == "n" &&
                txt.charAt(j + 2).toLowerCase() == "b" &&
                txt.charAt(j + 3).toLowerCase() == "s" &&
                txt.charAt(j + 4).toLowerCase() == "p" &&
                txt.charAt(j + 5).toLowerCase() == ";"
              ) {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  character: character,
                  next: "&nbsp;",
                  startAt: calculatedTime,
                };
                if (character != "") {
                  calculatedTime += 40;
                  cleanCharacterArray.push(obj);
                }
                charactersArray.push(obj);
                character = "";
                j = j + 5;
              } else if (txt.charAt(j) == " ") {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  character: character,
                  next: " ",
                  startAt: calculatedTime,
                };
                if (character != "") {
                  calculatedTime += 40;
                  cleanCharacterArray.push(obj);
                }
                charactersArray.push(obj);
                character = "";
                // j = j + 6;
              } else {
                if (character != "") {
                  let obj = {
                    id: `wbwf_${makeid(8)}`,
                    character: character,
                    next: "",
                    startAt: calculatedTime,
                  };
                  if (character != "") {
                    calculatedTime += 40;
                    cleanCharacterArray.push(obj);
                  }
                  charactersArray.push(obj);
                }
                character = txt.charAt(j);
              }
            }

            if (character != "") {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                character: character,
                next: "",
                startAt: calculatedTime,
              };
              if (character != "") {
                calculatedTime += 40;
                cleanCharacterArray.push(obj);
              }
              charactersArray.push(obj);
            }
            array[i].CharactersArray = charactersArray;
            array[i].cleanCharacterArray = cleanCharacterArray;

            array[i].startTransitionWidth = calculateWidthByDuration(
              msToTime(calculatedTime)
            );
            let minMsPrLetter =
              totalTimeToMs(
                calculateTimeByWidth(array[i].startTransitionWidth)
              ) / cleanCharacterArray.length;

            if (
              array[i].startTransitionWidth >
              array[i].widthOnTimeline - array[i].endTransitionWidth
            ) {
              minMsPrLetter =
                totalTimeToMs(
                  calculateTimeByWidth(
                    array[i].widthOnTimeline - array[i].endTransitionWidth
                  )
                ) / cleanCharacterArray.length;
              array[i].startTransitionWidth =
                array[i].widthOnTimeline - array[i].endTransitionWidth; //calculateWidthByDuration(msToTime(calculatedTime));
            }
            array[i].bounceInMs = minMsPrLetter;
            if (minMsPrLetter < 20) {
              alert("can not set transition: " + minMsPrLetter);
              array[i].startTransitionWidth = 0;
              array[i].bounceInMs = undefined;
              array[i].CharactersArray = undefined;
              array[i].cleanCharacterArray = undefined;
              effectConfigured = false;
            }
          } else if (types == "WordByWordFade") {
            var txt = array[i].text;
            let wordsArray = [];
            let cleanWordsArray = [];
            let word = "";
            let CalculatedTime = 0;
            let opacityIncrement = 0.03;
            let perWordFPS = 60;
            let perWordTimeout = (1 / opacityIncrement) * perWordFPS;
            let perWordMS = 200;

            for (let j = 0; j < txt.length; j++) {
              if (
                txt.charAt(j) == "<" &&
                txt.charAt(j + 1).toLowerCase() == "b" &&
                txt.charAt(j + 2).toLowerCase() == "r" &&
                txt.charAt(j + 3).toLowerCase() == ">"
              ) {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: "<br>",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime +=
                    perWordTimeout - (perWordTimeout - perWordMS);
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
                j = j + 3;
              } else if (
                txt.charAt(j) == "&" &&
                txt.charAt(j + 1).toLowerCase() == "n" &&
                txt.charAt(j + 2).toLowerCase() == "b" &&
                txt.charAt(j + 3).toLowerCase() == "s" &&
                txt.charAt(j + 4).toLowerCase() == "p" &&
                txt.charAt(j + 5).toLowerCase() == ";"
              ) {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: "&nbsp;",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime +=
                    perWordTimeout - (perWordTimeout - perWordMS);
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
                j = j + 5;
              } else if (txt.charAt(j) == " ") {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: " ",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime +=
                    perWordTimeout - (perWordTimeout - perWordMS);
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
                // j = j + 6;
              } else {
                word += txt.charAt(j);
              }
            }
            if (word != "") {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
            }

            array[i].WordsArray = wordsArray;
            array[i].startTransitionWidth = calculateWidthByDuration(
              msToTime(CalculatedTime)
            );

            //check if full width is smaller than transition then make it dynamic

            if (array[i].startTransitionWidth > array[i].widthOnTimeline / 2) {
              let MaxTotalMs = (array[i].widthOnTimeline / 2) * onePxEquivalent;
              let maxPerWordMs = MaxTotalMs / cleanWordsArray.length;
              let downSizePercentage = maxPerWordMs / perWordMS;
              let upsizeOpacityIncrement =
                opacityIncrement * (1 - downSizePercentage) + opacityIncrement;
              opacityIncrement = upsizeOpacityIncrement;
              perWordFPS = 60 * (1 - downSizePercentage) + 60;
              perWordTimeout = (1 / opacityIncrement) * perWordFPS;
              perWordMS = maxPerWordMs;
              wordsArray = [];
              cleanWordsArray = [];
              CalculatedTime = 0;

              for (let j = 0; j < txt.length; j++) {
                if (
                  txt.charAt(j) == "<" &&
                  txt.charAt(j + 1).toLowerCase() == "b" &&
                  txt.charAt(j + 2).toLowerCase() == "r" &&
                  txt.charAt(j + 3).toLowerCase() == ">"
                ) {
                  let obj = {
                    id: `wbwf_${makeid(8)}`,
                    word: word,
                    next: "<br>",
                    startAt: CalculatedTime,
                  };
                  if (word != "") {
                    CalculatedTime +=
                      perWordTimeout - (perWordTimeout - perWordMS);
                    cleanWordsArray.push(obj);
                  }
                  wordsArray.push(obj);
                  word = "";
                  j = j + 3;
                } else if (
                  txt.charAt(j) == "&" &&
                  txt.charAt(j + 1).toLowerCase() == "n" &&
                  txt.charAt(j + 2).toLowerCase() == "b" &&
                  txt.charAt(j + 3).toLowerCase() == "s" &&
                  txt.charAt(j + 4).toLowerCase() == "p" &&
                  txt.charAt(j + 5).toLowerCase() == ";"
                ) {
                  let obj = {
                    id: `wbwf_${makeid(8)}`,
                    word: word,
                    next: "&nbsp;",
                    startAt: CalculatedTime,
                  };
                  if (word != "") {
                    CalculatedTime +=
                      perWordTimeout - (perWordTimeout - perWordMS);
                    cleanWordsArray.push(obj);
                  }
                  wordsArray.push(obj);
                  word = "";
                  j = j + 5;
                } else if (txt.charAt(j) == " ") {
                  let obj = {
                    id: `wbwf_${makeid(8)}`,
                    word: word,
                    next: " ",
                    startAt: CalculatedTime,
                  };
                  if (word != "") {
                    CalculatedTime +=
                      perWordTimeout - (perWordTimeout - perWordMS);
                    cleanWordsArray.push(obj);
                  }
                  wordsArray.push(obj);
                  word = "";
                } else {
                  word += txt.charAt(j);
                }
              }
              if (word != "") {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: "",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime +=
                    perWordTimeout - (perWordTimeout - perWordMS);
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
              }
            }

            array[i].wordByWordFadeInData = {
              CalculatedTime: CalculatedTime,
              opacityIncrement: opacityIncrement,
              perWordFPS: perWordFPS,
              perWordTimeout: perWordTimeout,
              perWordMS: perWordMS,
              cleanWordsArray: cleanWordsArray,
            };

            array[i].WordsArray = wordsArray;
            array[i].startTransitionWidth = calculateWidthByDuration(
              msToTime(CalculatedTime + perWordMS)
            );
          } else if (types == "WordByWordAppear") {
            var txt = array[i].text;
            let wordsArray = [];
            let cleanWordsArray = [];
            let word = "";
            let CalculatedTime = 0;
            let opacityIncrement = 0.03;
            let perWordFPS = 60;
            let perWordTimeout = (1 / opacityIncrement) * perWordFPS;
            let perWordMS = 2000;

            for (let j = 0; j < txt.length; j++) {
              if (
                txt.charAt(j) == "<" &&
                txt.charAt(j + 1).toLowerCase() == "b" &&
                txt.charAt(j + 2).toLowerCase() == "r" &&
                txt.charAt(j + 3).toLowerCase() == ">"
              ) {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: "<br>",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime += perWordTimeout;
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
                j = j + 3;
              } else if (
                txt.charAt(j) == "&" &&
                txt.charAt(j + 1).toLowerCase() == "n" &&
                txt.charAt(j + 2).toLowerCase() == "b" &&
                txt.charAt(j + 3).toLowerCase() == "s" &&
                txt.charAt(j + 4).toLowerCase() == "p" &&
                txt.charAt(j + 5).toLowerCase() == ";"
              ) {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: "&nbsp;",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime += perWordTimeout;
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
                j = j + 5;
              } else if (txt.charAt(j) == " ") {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: " ",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime += perWordTimeout;
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
                // j = j + 6;
              } else {
                word += txt.charAt(j);
              }
            }
            if (word != "") {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout;
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
            }

            array[i].WordsArray = wordsArray;
            array[i].startTransitionWidth = calculateWidthByDuration(
              msToTime(CalculatedTime)
            );

            //check if full width is smaller than transition then make it dynamic

            if (array[i].startTransitionWidth > array[i].widthOnTimeline / 2) {
              let MaxTotalMs = (array[i].widthOnTimeline / 2) * onePxEquivalent;
              let maxPerWordMs = MaxTotalMs / cleanWordsArray.length;
              let downSizePercentage = maxPerWordMs / perWordMS;
              let upsizeOpacityIncrement =
                opacityIncrement * (1 - downSizePercentage) + opacityIncrement;
              opacityIncrement = upsizeOpacityIncrement;
              perWordFPS = maxPerWordMs / 60; //(60 * (1 - downSizePercentage)) + 60;
              perWordTimeout = (1 / opacityIncrement) * perWordFPS;
              perWordMS = maxPerWordMs;
              wordsArray = [];
              cleanWordsArray = [];
              CalculatedTime = 0;

              for (let j = 0; j < txt.length; j++) {
                if (
                  txt.charAt(j) == "<" &&
                  txt.charAt(j + 1).toLowerCase() == "b" &&
                  txt.charAt(j + 2).toLowerCase() == "r" &&
                  txt.charAt(j + 3).toLowerCase() == ">"
                ) {
                  let obj = {
                    id: `wbwf_${makeid(8)}`,
                    word: word,
                    next: "<br>",
                    startAt: CalculatedTime,
                  };
                  if (word != "") {
                    CalculatedTime += perWordMS;
                    cleanWordsArray.push(obj);
                  }
                  wordsArray.push(obj);
                  word = "";
                  j = j + 3;
                } else if (
                  txt.charAt(j) == "&" &&
                  txt.charAt(j + 1).toLowerCase() == "n" &&
                  txt.charAt(j + 2).toLowerCase() == "b" &&
                  txt.charAt(j + 3).toLowerCase() == "s" &&
                  txt.charAt(j + 4).toLowerCase() == "p" &&
                  txt.charAt(j + 5).toLowerCase() == ";"
                ) {
                  let obj = {
                    id: `wbwf_${makeid(8)}`,
                    word: word,
                    next: "&nbsp;",
                    startAt: CalculatedTime,
                  };
                  if (word != "") {
                    CalculatedTime += perWordMS;
                    cleanWordsArray.push(obj);
                  }
                  wordsArray.push(obj);
                  word = "";
                  j = j + 5;
                } else if (txt.charAt(j) == " ") {
                  let obj = {
                    id: `wbwf_${makeid(8)}`,
                    word: word,
                    next: " ",
                    startAt: CalculatedTime,
                  };
                  if (word != "") {
                    CalculatedTime += perWordMS;
                    cleanWordsArray.push(obj);
                  }
                  wordsArray.push(obj);
                  word = "";
                } else {
                  word += txt.charAt(j);
                }
              }
              if (word != "") {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: "",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime += perWordMS;
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
              }
            }
            let scaleDecriment = 10 / (1 / opacityIncrement);
            array[i].wordByWordFadeInData = {
              CalculatedTime: CalculatedTime,
              opacityIncrement: opacityIncrement,
              perWordFPS: perWordFPS,
              perWordTimeout: perWordTimeout,
              perWordMS: perWordMS,
              cleanWordsArray: cleanWordsArray,
              scaleDecriment: scaleDecriment,
            };
            array[i].WordsArray = wordsArray;
            array[i].startTransitionWidth = calculateWidthByDuration(
              msToTime(CalculatedTime + perWordMS)
            );
          } else {
            array[i].startTransitionWidth =
              calculateWidthByDuration("00:00:00:500");
          }
          if (array[i].AzData != null) {
            if (array[i].endTransitionWidth != 0) {
              if (
                array[i].AzData.widthOnTimeline +
                  array[i].startTransitionWidth +
                  array[i].endTransitionWidth >=
                array[i].widthOnTimeline
              ) {
                array[i].AzData.widthOnTimeline =
                  array[i].AzData.widthOnTimeline -
                  array[i].startTransitionWidth;
              }
            } else {
              if (
                array[i].AzData.widthOnTimeline +
                  array[i].startTransitionWidth >=
                array[i].widthOnTimeline
              ) {
                array[i].AzData.widthOnTimeline =
                  array[i].AzData.widthOnTimeline -
                  array[i].startTransitionWidth;
              }
            }
          }
          if (effectConfigured) {
            array[i].InEffect = `animated ${types} `;
            array[i].originalWidth = array[i].width;
            array[i].originalHeight = array[i].height;
            array[i].originalX = array[i].x;
            array[i].originalY = array[i].y;
            array[i].originalOpacity = array[i].opacity;
            if (array[i].type == "text") {
              array[i].originalFontSize = array[i].fontSize;
              array[i].originalText = array[i].text;
            }
          }
        } else if (currentData.point == "end") {
          array[i].endTransitionWidth =
            calculateWidthByDuration("00:00:00:500");

          if (array[i].AzData != null) {
            if (array[i].startTransitionWidth != 0) {
              if (
                array[i].AzData.widthOnTimeline +
                  array[i].startTransitionWidth +
                  array[i].endTransitionWidth >=
                array[i].widthOnTimeline
              ) {
                array[i].AzData.widthOnTimeline =
                  array[i].AzData.widthOnTimeline - array[i].endTransitionWidth;
              }
            } else {
              if (
                array[i].AzData.widthOnTimeline + array[i].endTransitionWidth >=
                array[i].widthOnTimeline
              ) {
                array[i].AzData.widthOnTimeline =
                  array[i].AzData.widthOnTimeline - array[i].endTransitionWidth;
              }
            }
          }

          array[i].OutEffect = `animated ${types} `;
          array[i].originalWidth = array[i].width;
          array[i].originalHeight = array[i].height;
          array[i].originalX = array[i].x;
          array[i].originalY = array[i].y;
          array[i].originalOpacity = array[i].opacity;
          array[i].istts = "true";
          array[i].ttspath = "pathssss";

          if (array[i].type == "text") {
            array[i].originalFontSize = array[i].fontSize;
            array[i].originalText = array[i].text;
          }
        }
      }
    }
    props.setLayersData(array);
    setcurrentData({
      key: currentData.key,
      point: currentData.point,
      activeTransition: `animated ${types} `,
    });
    //console.log("cur dtaa =");
    //console.log(currentData);
  };
  const removeTransition = () => {
    const array = Array.from(props.LayersData);

    for (let i = 0; i < array.length; i++) {
      if (array[i].key == currentData.key) {
        if (currentData.point == "start") {
          array[i].InEffect = `none`;
        } else if (currentData.point == "end") {
          array[i].OutEffect = `none`;
        }
      }
    }
    props.setLayersData(array);
  };
  const elemref = useRef(null);

  useEffect(() => {
    if (Show) {
      elemref.current.focus();
    }
  }, [Show]);

  return (
    <>
      {Show && (
        <div
          ref={elemref}
          onBlur={() => {
            setShow(false);
            setcurrentData({ key: null, point: null });
          }}
          className="Setting_Container2"
          tabIndex="0"
          onMouseLeave={() => {
            setShow(false);
            setcurrentData({ key: null, point: null });
          }}
          style={{
            top: props.style.top - 100 + "px",
            left: props.style.left,
            zIndex: 99999999,
          }}
        >
          <div
            className="Setting_Box style-1"
            style={{ width: "300px", height: "300px", overflowY: "auto" }}
          >
            <div style={{ width: "100%", height: "100%" }}>
              <div className="Setting_Menu" style={{ width: "152px" }}>
                {currentData.point == "start" && (
                  <div
                    className="Setting_Menu_Items2 Setting_Menu_Items"
                    style={{ width: "289px" }}
                  >
                    <div
                      style={{
                        width: "100%",
                        fontWeight: "bold",
                        marginTop: "8px",
                        marginLeft: "6px",
                      }}
                    >
                      <span className="labelstyle">In Effects</span>
                    </div>

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        removeTransition();
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated slideInRight "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <span
                              class="material-icons"
                              style={{ margin: "23px" }}
                            >
                              block
                            </span>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            Remove
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* //  working on this In Effects after Demo */}
                    {/* {CurrentLayerData.type == "text" && (
                      <>
                        <div
                          className="Setting_Single_items"
                          style={{ paddingTop: "11px" }}
                          onClick={() => {
                            settransition("TextBounce");
                          }}
                        >
                          <div className="color_container">
                            <div className="styles_button">
                              <div
                                className="Style_Button_style"
                                style={{
                                  background:
                                    currentData.activeTransition ==
                                    "TextBounce "
                                      ? "#e7e8ff"
                                      : "",
                                }}
                              >
                                <img
                                  src="../AnimatedIcons/Text_bounce.gif"
                                  style={{ width: "100%" }}
                                ></img>
                              </div>
                              <div
                                className="styles_title"
                                style={{ paddingTop: "7px" }}
                              >
                                Text Bounce
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="Setting_Single_items"
                          style={{ paddingTop: "11px" }}
                          onClick={() => {
                            settransition("TypeWriter");
                          }}
                        >
                          <div className="color_container">
                            <div className="styles_button">
                              <div
                                className="Style_Button_style"
                                style={{
                                  background:
                                    currentData.activeTransition ==
                                    "TypeWriter "
                                      ? "#e7e8ff"
                                      : "",
                                }}
                              >
                                <img
                                  src="../AnimatedIcons/Text_type.gif"
                                  style={{ width: "100%" }}
                                ></img>
                              </div>
                              <div
                                className="styles_title"
                                style={{ paddingTop: "7px" }}
                              >
                                Type Writer
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="Setting_Single_items"
                          style={{ paddingTop: "11px" }}
                          onClick={() => {
                            settransition("WordByWordFade");
                          }}
                        >
                          <div className="color_container">
                            <div className="styles_button">
                              <div
                                className="Style_Button_style"
                                style={{
                                  background:
                                    currentData.activeTransition ==
                                    "TypeWriter "
                                      ? "#e7e8ff"
                                      : "",
                                }}
                              >
                                <img
                                  src="../AnimatedIcons/Word_fade.gif"
                                  style={{ width: "100%" }}
                                ></img>
                              </div>
                              <div
                                className="styles_title"
                                style={{ paddingTop: "7px" }}
                              >
                                Word fade
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="Setting_Single_items"
                          style={{ paddingTop: "11px" }}
                          onClick={() => {
                            settransition("WordByWordAppear");
                          }}
                        >
                          <div className="color_container">
                            <div className="styles_button">
                              <div
                                className="Style_Button_style"
                                style={{
                                  background:
                                    currentData.activeTransition ==
                                    "TypeWriter "
                                      ? "#e7e8ff"
                                      : "",
                                }}
                              >
                                <img
                                  src="../AnimatedIcons/Text_appear.gif"
                                  style={{ width: "100%" }}
                                ></img>
                              </div>
                              <div
                                className="styles_title"
                                style={{ paddingTop: "7px" }}
                              >
                                Word Appear
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )} */}

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("slideInRight");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated slideInRight "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/Left.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            From Right
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("slideInLeft");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated slideInLeft "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/right.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            From Left
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("slideInDown");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated slideInDown "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/down.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            From Top
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("slideInUp");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated slideInUp "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/up.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            From Bottom
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("zoomIn");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated zoomIn "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/ZoomIn.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            Zoom In
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="Setting_Single_items" style={{ paddingTop: "11px" }} onClick={() => { settransition("Zoom Out") }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div className="Style_Button_style" style={{ background: currentData.activeTransition == "animated Zoom Out " ? '#e7e8ff' : '' }}>

                            <img src="../AnimatedIcons/ZoomOut.gif" style={{ width: '100%' }}></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            Zoom Out
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("fadeIn");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated fadeIn "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/FadeIn.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            Fade In
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {currentData.point == "end" && (
                  <div
                    className="Setting_Menu_Items2 Setting_Menu_Items"
                    style={{ width: "289px" }}
                  >
                    <div
                      style={{
                        width: "100%",
                        fontWeight: "bold",
                        marginTop: "8px",
                        marginLeft: "6px",
                      }}
                    >
                      <span className="labelstyle"> Out Effects</span>
                    </div>

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        removeTransition();
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated slideInRight "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <span
                              class="material-icons"
                              style={{ margin: "23px" }}
                            >
                              block
                            </span>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            Remove
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("slideOutLeft");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated slideOutLeft "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/Left.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            To Left
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("slideOutRight");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated slideOutRight "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/Right.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            To Right
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("slideOutDown");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated slideOutDown "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/Down.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            To Bottom
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("slideOutUp");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated slideOutUp "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/up.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            To Top
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="Setting_Single_items" style={{ paddingTop: "11px" }} onClick={() => { settransition("zoomOut") }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div className="Style_Button_style" style={{ background: currentData.activeTransition == "animated zoomOut " ? '#e7e8ff' : '' }}>

                            <img src="../AnimatedIcons/ZoomIn.gif" style={{ width: '100%' }}></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            Zoom Out
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("zoomOut");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated zoomOut "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/ZoomOut.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            Zoom Out
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="Setting_Single_items"
                      style={{ paddingTop: "11px" }}
                      onClick={() => {
                        settransition("fadeOut");
                      }}
                    >
                      <div className="color_container">
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            style={{
                              background:
                                currentData.activeTransition ==
                                "animated fadeOut "
                                  ? "#e7e8ff"
                                  : "",
                            }}
                          >
                            <img
                              src="../AnimatedIcons/FadeOut.gif"
                              style={{ width: "100%" }}
                            ></img>
                          </div>
                          <div
                            className="styles_title"
                            style={{ paddingTop: "7px" }}
                          >
                            Fade Out
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="dropUpArrow"></div>
        </div>
      )}
    </>
  );
};

export default SlideSettings;
